var formatVideoIframeUrl = function formatVideoIframeUrl(videoIframeUrl) {
  return "".concat(videoIframeUrl, "&pegasusDisabled=1&npr=1&startOnSight=0");
};

export default formatVideoIframeUrl;